var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicOff = function SvgMicOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-262.000000, -120.000000)",
    fill: "#151B22",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.388889,109.473684 L255.594444,109.473684 C255.594444,110.252632 255.425556,110.978947 255.140556,111.631579 L256.438889,112.926316 C257.03,111.894737 257.388889,110.726316 257.388889,109.473684 L257.388889,109.473684 Z M253.145556,109.652632 C253.145556,109.589474 253.166667,109.536842 253.166667,109.473684 L253.166667,103.157895 C253.166667,101.410526 251.752222,100 250,100 C248.247778,100 246.833333,101.410526 246.833333,103.157895 L246.833333,103.347368 L253.145556,109.652632 Z M241.840556,101.052632 L240.5,102.389474 L246.843889,108.715789 L246.843889,109.473684 C246.843889,111.221053 248.247778,112.631579 250,112.631579 C250.232222,112.631579 250.464444,112.6 250.686111,112.547368 L252.438333,114.294737 C251.688889,114.642105 250.855,114.842105 250,114.842105 C247.086667,114.842105 244.405556,112.631579 244.405556,109.473684 L242.611111,109.473684 C242.611111,113.063158 245.482222,116.031579 248.944444,116.547368 L248.944444,120 L251.055556,120 L251.055556,116.547368 C252.016111,116.410526 252.923889,116.073684 253.736667,115.6 L258.159444,120 L259.5,118.663158 L241.840556,101.052632 Z",
    id: "Mic-off"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic-off.7d0aacec.svg";
export { ForwardRef as ReactComponent };